import { Badge } from '@shopify/polaris';
import type { MatchSource } from '../api/vehicles';

type Tone = 'success' | 'info' | 'warning' | 'attention' | 'critical';

const MATCH_SOURCE: Record<MatchSource, { tone: Tone; label: string }> = {
  canonical: { tone: 'success', label: 'Canonical' },
  alias: { tone: 'info', label: 'Alias' },
  tolerance: { tone: 'warning', label: 'Tolerance' },
};

export function MatchSourceBadge({ source }: { source: MatchSource | null }) {
  if (!source) return <Badge tone="attention">Unknown</Badge>;
  const { tone, label } = MATCH_SOURCE[source];
  return <Badge tone={tone}>{label}</Badge>;
}

const CONFIDENCE: Record<string, { tone: Tone; label: string }> = {
  exact: { tone: 'success', label: 'Exact' },
  alias: { tone: 'info', label: 'Alias' },
  tolerance: { tone: 'warning', label: 'Tolerance' },
  override: { tone: 'attention', label: 'Override' },
};

export function ConfidenceBadge({ confidence }: { confidence: string | null }) {
  if (!confidence) return <Badge tone="attention">Unknown</Badge>;
  const entry = CONFIDENCE[confidence] ?? { tone: 'attention' as Tone, label: confidence };
  return <Badge tone={entry.tone}>{entry.label}</Badge>;
}
